<template>
  <HeaderIconButton
    v-if="!isOpen"
    @click="open"
  >
    <template #icon>
      <MagnifierCircleSvg />
    </template>

    <template #label>
      Search
    </template>
  </HeaderIconButton>
  <div
    v-else
    :class="$style.inputWrapper"
  >
    <MagnifierCircleSvg :class="$style.magnifierOpen" />
    <input
      ref="input"
      v-model.trim="value"
      type="text"
      :class="$style.input"
      :placeholder="placeholder"
      @blur="checkState"
      @input="input"
      @change="change"
    >
    <button
      type="button"
      :class="$style.clear"
      @click="clear"
    >
      <CrossSvg :class="$style.crossOpen" />
    </button>
  </div>
</template>

<script>
import HeaderIconButton from '@/components/HeaderIconButton';
import MagnifierCircleSvg from '@/assets/images/icons/magnifier-circle.svg?inline';
import CrossSvg from '@/assets/images/icons/cross.svg?inline';

export default {
  components: {
    HeaderIconButton,
    MagnifierCircleSvg,
    CrossSvg,
  },
  props: {
    placeholder: {
      type: String,
      default: null,
    },
  },
  emits: {
    input: null,
    change: null,
  },
  data() {
    return {
      isOpen: false,
      value: '',
    };
  },
  methods: {
    close() {
      this.isOpen = false;
    },
    open() {
      this.isOpen = true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    clear() {
      this.value = '';
      this.change();
      this.$refs.input.focus();
    },
    checkState() {
      if (!this.isOpen) return;

      if (this.value === '') {
        this.close();
      }
    },
    input(e) {
      this.$emit('input', this.value, e);
    },
    change(e) {
      this.$emit('change', this.value, e);
    },
  },
};
</script>

<style lang="scss" module>
.inputWrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.input {
  padding: 6px 25px 5px;
  overflow: hidden;
  font-size: 15px;
  font-weight: 600;
  color: $title;
  background: $background-light;
  border: 0;
  border-radius: 10px;
  box-shadow: none;

  &::placeholder {
    color: rgba($title, 0.5);
  }
}

.magnifierOpen {
  position: absolute;
  top: 50%;
  left: 3px;
  pointer-events: none;
  transform: translateY(-50%);
}

.clear {
  @include reset;
  position: absolute;
  top: 50%;
  right: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-size: 0;
  color: $disabled;
  cursor: pointer;
  border-radius: 50%;
  transition: color 0.2s ease-in-out;
  transform: translateY(-50%);

  &:hover {
    color: $title;
  }
}

.crossOpen {
  width: 8px;
  height: auto;
}
</style>
